import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  
  ResetPasswordForm: FormGroup;
  token: string | null = null;
  email: string;
  userName: string;
  storeDetails = {};
  featureTags = {};
  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private notification: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    // Extract the token from URL (param)
    this.route.params.subscribe(params => {
      this.token = params['token'];
      this.validateToken(this.token);
    });

    this.ResetPasswordForm = this.formBuilder.group({
      email: [{ value: this.email, disabled: true }],
      password: ['', [Validators.required, Validators.minLength(6)]],
      cpassword: ['', [Validators.required, Validators.minLength(6)]]
    });
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
        this.storeDetails = this.route.snapshot.data['store']['response']['data']['store']; 
    } 
  }

  onResetPasswordFormFormSubmit(): void {
    if (this.ResetPasswordForm.valid) {
      const formValues = this.ResetPasswordForm.value;
      
      if (formValues.password !== formValues.cpassword) {
        this.notification.error('Passwords do not match');
        return;
      }

      // Handle form submission
      let data={
        email: this.email,
        password: formValues.password 
      }
      this.apiService.updateResetPassword(data).subscribe(
        (response: any) => {
          if (response['response']['status'] == 1) {                        
            this.notification.success(response['response']['message']);
            let loginData= {}

            loginData = {
              email_id: this.email,
              password: formValues.password,
              rememberMe: false
            }    
            localStorage.setItem("token", response["response"]["data"]['token']);   
            setTimeout(() =>  {
              this.setLoginDetails(response["response"]["data"]);
              if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                if(this.storeDetails['enable_bulletin_board'] == true){
                  if(this.storeDetails['bulletin_board_as_landing'] == true){
                    this.router.navigate(["/account/bulletinboard"]) 
                  }else{
                    this.router.navigate(["/account/orders"]) 
                  }
                }else{
                  this.router.navigate(["/account/orders"]) 
                }
              }else{
                this.router.navigate(["/shop"])
              }
              this.notification.success(
                response["response"].message,
                5000
            );
            }, 2000);
          } else {
            // Token is invalid, show an error and handle accordingly
            this.notification.error(response['response']['message']);
          }
        });
    }
  }

  setLoginDetails(response: any) {
    // sessionStorage.setItem("token", response.token);
    this.apiService.setLogin({
        loggedIn: true,
        userDetails: response.user_details,
    });
    sessionStorage.setItem("order_exist", response["order_exist"]);

    this.notification.success("You logged in successfully!", 5000);
  }

  validateToken(token){    
    if(token){
      this.apiService.resetPasswordToken(token).subscribe(
        (response: any) => {
          if (response['response']['status'] == 1) {
            // Token is valid, allow the user to proceed
            this.userName = response['response']['contact']['first_name']+' '+response['response']['contact']['last_name'];            
            this.email = response['response']['contact']['email_id'];
            this.ResetPasswordForm.patchValue({
              email: response['response']['contact']['email_id']
            });
          } else {
            // Token is invalid, show an error and handle accordingly
            this.notification.error(response['response']['message']);
            this.router.navigate(['/sign-in']);  // Redirect to an error page if token is invalid
          }
        }
      );
    }
  }

}
